// @avantia common-code
import { Policy } from '../types/policyTypes';
import { createMockPolicy } from './shared';

export const label = 'Contents';

export const policy: Policy = createMockPolicy({
  policyNumber: 'C12/11000001',
  policyDetailsId: '110000011001',
  forename: 'Albert',
  coverType: 'Contents'
});
